export const prodadminHosts = [
  'https://prodadmin.myxplor.com',
  'https://staging-admin.myxplor.com',
  'https://staging-web.myxplor.com',
  'https://staging-office.myxplor.com',
  'https://office.myxplor.com',
  'https://prodadmin.uktst.myxplor.com',
  'https://prodadmin.uk.myxplor.com'
]

export const isIFrame = window.self !== window.top
